var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FormSelect_instances, _FormSelect_appendCountries;
import $ from 'jquery';
import "select2/dist/js/select2.full.js";
export class FormSelect {
    constructor() {
        _FormSelect_instances.add(this);
        this.selector = '.form-select';
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            const { config } = element.dataset;
            let datasetConfig = {};
            if (typeof config !== "undefined") {
                const parsedConfig = JSON.parse(config);
                datasetConfig = parsedConfig;
            }
            if ('dropdownParent' in datasetConfig) {
                datasetConfig.dropdownParent = $(datasetConfig.dropdownParent);
            }
            if ($(element).hasClass('select-countries')) {
                __classPrivateFieldGet(this, _FormSelect_instances, "m", _FormSelect_appendCountries).call(this, element);
            }
            $(element).select2(datasetConfig);
        });
        $(document).on('select2:open', () => {
            $('.select2-search__field').trigger('focus');
        });
    }
}
_FormSelect_instances = new WeakSet(), _FormSelect_appendCountries = async function _FormSelect_appendCountries(element) {
    const response = await fetch('/api/countries');
    const jsonData = await response.json();
    let html = '';
    for (const key in jsonData) {
        html += `<option value="${jsonData[key]}">${jsonData[key]}</option>`;
    }
    $(element).append(html);
};
